import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'summaryAmount',
  standalone: false,
})
export class SummaryAmountPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return '';
    }
    const number = Number(value);
    return !isNaN(number) ? (Math.floor(number * 100) / 100).toString() : value;
  }
}
